
import functions from '@/util/functions';
/**
 * 按题目随机
 * @param quesList 试题list
 * @param list 抽题条件list
 * @return Array
 */
export const randomType2 = (quesList, list) => {
    let newList = [], result = []
    let arr = quesList.filter(info => {
        return info.questionsTypeId != '25' && info.questionsTypeId != '26'
    })
    list.forEach(item => {
        let itemArr = []
        arr.forEach((info) => {
            if (info.quesIndex + 1 >= item.startNum && info.quesIndex + 1 <= item.endNum) {
                itemArr.push(info)
            }
            if (info.quesIndex + 1 == item.endNum) {
                newList.push(itemArr)
            }
        })
    })
    newList.forEach((info, index) => {
        let randomArray = functions.GetRandomArray(info, list[index].sum)
        result = [...result,...randomArray]
    }) 
    return result
}